/**
 * BE BOLD : Path A: Strengthen and Build
 * Month 3: Foundation Peak (Days 61-90)
 *
 * Squeeze 60-70%, hold 8-10s. Fast squeezes. Bridge.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  bridge_activation: {
    id: 'bridge_activation',
    name: 'Bridge Activation',
    name_pt: 'Ponte com Ativação',
    sub: 'Squeeze first, then lift hips. Always this order.',
    sub_pt: 'Aperte primeiro, depois levante quadril. Sempre essa ordem.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie on your back, knees bent, feet flat.

Squeeze pelvic floor first. THEN lift hips into a bridge. Hold bridge AND squeeze for 5 seconds.

Lower hips slowly. Release squeeze as hips touch ground.

The sequence: floor first, then hips. Always.

Picture it: a drawbridge raising. Chains pull first (pelvic floor), THEN bridge lifts (hips). Chains always lead.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Aperte assoalho primeiro. DEPOIS levante quadril em ponte. Segure ponte E aperto por 5 segundos.

Abaixe quadril devagar. Solte aperto quando quadril tocar chão.

A sequência: assoalho primeiro, depois quadril. Sempre.

Visualize: ponte levadiça subindo. Correntes puxam primeiro (assoalho), DEPOIS ponte sobe (quadril). Correntes sempre lideram.`,
    breathe: 'Exhale to squeeze and lift. Inhale to lower and release.',
    breathe_pt: 'Expire para apertar e levantar. Inspire para abaixar e soltar.',
    timerCue: `Squeeze.
Lift.
Hold.
Lower.`,
    timerCue_pt: `Aperte.
Levante.
Segure.
Abaixe.`,
    feel: 'Floor and glutes working together. The floor starts first.',
    feel_pt: 'Assoalho e glúteos trabalhando juntos. O assoalho começa primeiro.',
    avoid: 'Do not lift before squeezing. Do not hold breath. Do not bear down.',
    avoid_pt: 'Não levante antes de apertar. Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 10,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  fast_squeeze: {
    id: 'fast_squeeze',
    name: 'Fast Squeeze',
    name_pt: 'Aperto Rápido',
    sub: 'Maximum effort. 1 second. Full release.',
    sub_pt: 'Esforço máximo. 1 segundo. Soltura total.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand, feet hip-width apart. Squeeze at maximum effort for 1 second. Release completely for 2 seconds.

This targets fast-twitch fibers that handle pressure spikes: coughing, laughing, sneezing, jumping.

Picture it: flicking a light switch. On for 1 second. Off completely. No dimming.`,
    inst_pt: `Fique de pé, pés na largura do quadril. Aperte com esforço máximo por 1 segundo. Solte completamente por 2 segundos.

Isso trabalha fibras rápidas que lidam com picos de pressão: tosse, risada, espirro, salto.

Visualize: interruptor de luz. Liga 1 segundo. Desliga completamente. Sem dimmer.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze!
Release.`,
    timerCue_pt: `Aperte!
Solte.`,
    feel: 'Sharp, fast contraction. Full instant release.',
    feel_pt: 'Contração aguda e rápida. Soltura instantânea total.',
    avoid: 'Do not let tension linger. Do not bear down.',
    avoid_pt: 'Não deixe tensão persistir. Não faça força.',
    type: 'pulse',
    sets: 4,
    rest: 10,
    reps: 12,
    on: 1,
    off: 2,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  pulsacao: {
    id: 'pulsacao',
    name: 'Pulsação',
    name_pt: 'Pulsação',
    sub: '1 second on, 1 second off. Clean rhythm. Each rep starts fresh.',
    sub_pt: '1 segundo liga, 1 segundo desliga. Ritmo limpo. Cada repetição começa limpa.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit with feet flat. CLOSE and SQUEEZE for 1 second. Release completely for 1 second. That is one rep.

Each contraction is independent. Do not let tension accumulate across reps. The release is 50% of the exercise.

After each set, do 3 Gentle Pushes to confirm full rest.

Picture it: a camera shutter. Click open, click closed. Sharp and complete. No blur between open and closed.`,
    inst_pt: `Sente com pés apoiados. FECHE e APERTE por 1 segundo. Solte completamente por 1 segundo. Isso é uma repetição.

Cada contração é independente. Não deixe tensão acumular. A soltura é 50% do exercício.

Após cada série, faça 3 Empurrões Suaves para confirmar repouso.

Visualize: obturador de câmera. Clique abre, clique fecha. Nítido e completo. Sem borrão.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Release.`,
    timerCue_pt: `Aperte.
Solte.`,
    feel: 'Clean on-off rhythm. Release as complete as contraction.',
    feel_pt: 'Ritmo liga-desliga limpo. Soltura tão completa quanto contração.',
    avoid: 'Do not let tension build across reps. Do not bear down.',
    avoid_pt: 'Não deixe tensão acumular entre repetições. Não faça força.',
    type: 'pulse',
    sets: 5,
    rest: 10,
    reps: 12,
    on: 1,
    off: 1,
  },

  squeeze_10s: {
    id: 'squeeze_10s',
    name: 'Peak Hold 10s',
    name_pt: 'Sustentação Pico 10s',
    sub: '70% effort. 10 seconds.',
    sub_pt: '70% de esforço. 10 segundos.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit on chair. CLOSE and SQUEEZE 70%. Hold 10 seconds. Release 10 seconds.

If you cannot hold 10 seconds, hold as long as you can and note the time. Build from there.

Picture it: climbing stairs. Step 1 at 3 seconds. Step 2 at 5. Step 3 at 8. Step 4 at 10. Rest on each landing.`,
    inst_pt: `Sente na cadeira. FECHE e APERTE 70%. Segure 10 segundos. Solte 10 segundos.

Se não conseguir segurar 10 segundos, segure o quanto puder e anote. Construa a partir daí.

Visualize: subindo escadas. Degrau 1 em 3 segundos. Degrau 2 em 5. Degrau 3 em 8. Degrau 4 em 10. Descanse em cada patamar.`,
    breathe: 'Exhale to engage. Breathe while holding.',
    breathe_pt: 'Expire para engajar. Respire enquanto segura.',
    timerCue: `Squeeze.
Hold 10.
Release.`,
    timerCue_pt: `Aperte.
Segure 10.
Solte.`,
    feel: 'Strong sustained lift. A growing tiredness in the floor as the reps build.',
    feel_pt: 'Elevação sustentada forte. Cansaço crescente no assoalho conforme as repetições avançam.',
    avoid: 'Do not hold breath. Do not bear down.',
    avoid_pt: 'Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 8,
    hold: 10,
    relax: 10,
    rest: 0,
  },

  squeeze_8s: {
    id: 'squeeze_8s',
    name: 'Strong Hold 8s',
    name_pt: 'Sustentação Forte 8s',
    sub: '60% effort. 8 seconds. The last 2 seconds build strength.',
    sub_pt: '60% esforço. 8 segundos. Os últimos 2 segundos constroem força.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie down or sit. CLOSE and SQUEEZE at 60%. Hold 8 seconds. Breathe normally. The muscle should hold without fading. If it fades at 5 seconds, that is your edge. The edge is where growth happens.

Release completely for 8 seconds.

Picture it: holding a plank. Your body shakes at the limit. That shake is strength building.`,
    inst_pt: `Deite ou sente. FECHE e APERTE em 60%. Segure 8 segundos. Respire normal. O músculo deve se manter. Se enfraquecer em 5 segundos, esse é seu limite. O limite é onde o crescimento acontece.

Solte completamente por 8 segundos.

Visualize: segurando prancha. Corpo treme no limite. Tremor é força construindo.`,
    breathe: 'Exhale to engage. Breathe while holding.',
    breathe_pt: 'Expire para engajar. Respire enquanto segura.',
    timerCue: `Squeeze.
Hold 8.
Release.`,
    timerCue_pt: `Aperte.
Segure 8.
Solte.`,
    feel: 'Strong sustained lift. A trembling or harder pull near the end of the hold.',
    feel_pt: 'Elevação sustentada forte. Tremor ou puxada mais intensa perto do fim da sustentação.',
    avoid: 'Do not hold breath. Do not bear down. Do not compensate with glutes.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não compense com glúteos.',
    type: 'hold',
    sets: 10,
    hold: 8,
    relax: 8,
    rest: 0,
  },
};

export const days = [
  {
    day: 61, week: 9,
    title: 'Day 61', title_pt: 'Dia 61',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 62, week: 9,
    title: 'Day 62', title_pt: 'Dia 62',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 63, week: 9,
    title: 'Day 63', title_pt: 'Dia 63',
    exercises: [
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'squeeze_8s', overrides: {"sets": 7} }, // 112s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 64, week: 10,
    title: 'Day 64', title_pt: 'Dia 64',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'gentle_push_reset', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 65, week: 10,
    title: 'Day 65', title_pt: 'Dia 65',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 66, week: 10,
    title: 'Day 66', title_pt: 'Dia 66',
    exercises: [
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 67, week: 10,
    title: 'Day 67', title_pt: 'Dia 67',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 68, week: 10,
    title: 'Day 68', title_pt: 'Dia 68',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 69, week: 10,
    title: 'Day 69', title_pt: 'Dia 69',
    exercises: [
      { ref: 'fast_squeeze', overrides: {"sets": 3} }, // 128s
      { ref: 'belly_breath_drop', overrides: {"sets": 17} }, // 170s
    ], // Total: 298s = 5.0 min
  },
  {
    day: 70, week: 10,
    title: 'Day 70', title_pt: 'Dia 70',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
      { ref: 'squeeze_8s', overrides: {"sets": 7} }, // 112s
    ], // Total: 294.0s = 4.9 min
  },
  {
    day: 71, week: 11,
    title: 'Day 71', title_pt: 'Dia 71',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 72, week: 11,
    title: 'Day 72', title_pt: 'Dia 72',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 73, week: 11,
    title: 'Day 73', title_pt: 'Dia 73',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 74, week: 11,
    title: 'Day 74', title_pt: 'Dia 74',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'fast_squeeze', overrides: {"sets": 3} }, // 128s
    ], // Total: 320s = 5.3 min
  },
  {
    day: 75, week: 11,
    title: 'Day 75', title_pt: 'Dia 75',
    exercises: [
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'bridge_activation', overrides: {"sets": 12} }, // 120s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 76, week: 11,
    title: 'Day 76', title_pt: 'Dia 76',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 77, week: 11,
    title: 'Day 77', title_pt: 'Dia 77',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'bridge_activation', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 78, week: 12,
    title: 'Day 78', title_pt: 'Dia 78',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 79, week: 12,
    title: 'Day 79', title_pt: 'Dia 79',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'bridge_activation', overrides: {} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 80, week: 12,
    title: 'Day 80', title_pt: 'Dia 80',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'child_pose_release', overrides: {"hold": 140} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 81, week: 12,
    title: 'Day 81', title_pt: 'Dia 81',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 82, week: 12,
    title: 'Day 82', title_pt: 'Dia 82',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 83, week: 12,
    title: 'Day 83', title_pt: 'Dia 83',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 84, week: 12,
    title: 'Day 84', title_pt: 'Dia 84',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 85, week: 13,
    title: 'Day 85', title_pt: 'Dia 85',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'pulsacao', overrides: {"sets": 4} }, // 126s
    ], // Total: 286s = 4.8 min
  },
  {
    day: 86, week: 13,
    title: 'Day 86', title_pt: 'Dia 86',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'fast_squeeze', overrides: {"sets": 3} }, // 128s
    ], // Total: 288s = 4.8 min
  },
  {
    day: 87, week: 13,
    title: 'Day 87', title_pt: 'Dia 87',
    exercises: [
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 88, week: 13,
    title: 'Day 88', title_pt: 'Dia 88',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
      { ref: 'gentle_push_reset', overrides: {"sets": 16} }, // 160s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 89, week: 13,
    title: 'Day 89', title_pt: 'Dia 89',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
      { ref: 'child_pose_release', overrides: {"hold": 118} }, // 118s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 90, week: 13,
    title: 'Day 90', title_pt: 'Dia 90',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
];

export const milestone = {
  title: 'Month 3 Check-in',
  title_pt: 'Check-in do Mes 3',
  questions: [
    {
      q: 'Can you hold 10 seconds and do bridges?',
      q_pt: 'Consegue segurar 10 segundos e fazer pontes?',
      yes_response: 'You are on track. Continue to the next month.',
      yes_response_pt: 'Voce esta no caminho. Continue para o proximo mes.',
      no_response: 'Repeat this month for 2 more weeks. If no progress after 6 weeks total, consult a pelvic floor physiotherapist.',
      no_response_pt: 'Repita este mes por mais 2 semanas. Se sem progresso apos 6 semanas, consulte fisioterapeuta de assoalho pelvico.',
    },
  ],
};

export const monthMeta = {
  month: 3,
  program: 'weak_pf',
  phase: 'Foundation Peak',
  phase_pt: 'Pico da Base',
  days_range: [61, 90],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}